import classNames from "classnames";
import style from "./MenuItem.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

function replaceSection(pathname, base, newSection) {
  const regExp = new RegExp(
    `(/(?:guidelines|app/nav)/${base})(?:/[^/]+)?$`,
    "i",
  );
  const match = pathname.match(regExp);
  if (match) {
    return pathname.replace(regExp, `$1/${newSection}`);
  }
  return newSection;
}

export const MenuItem = (props) => {
  const {
    title,
    msPath,
    isExternal,
    children,
    level,
    id,
    base,
    hasIconOption = true,
  } = props;
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = () => {
    if (isExternal) {
      window.open(msPath, "_blank", "noopener,noreferrer");
      return;
    }

    const targetUrl = getNavigationTarget();
    if (targetUrl) {
      if (targetUrl.startsWith("/")) {
        navigate(targetUrl);
      } else {
        navigate(replaceSection(pathname, base, targetUrl));
      }
    }
  };

  const getNavigationTarget = () => {
    if (!msPath) return null;

    if (msPath.startsWith("http")) {
      return null;
    }

    if (children?.length > 0) {
      const urlParams = new URLSearchParams(msPath);

      if (
        urlParams.has("sectionId") &&
        !urlParams.get("sectionId").includes("topic_1")
      ) {
        const sectionId = urlParams.get("sectionId").split("#")[0];
        return sectionId || msPath.split("/")[0];
      }

      if (level === "1" && id) {
        const decoded = decodeURIComponent(id);
        const ditaPart = decoded
          .split("/")
          .find((part) => part.includes(".dita"));
        const ditaPath = ditaPart
          ? ditaPart.replace(".dita", "")
          : decoded.split("/")[1];
        if (!pathname.includes(ditaPath)) {
          return ditaPath;
        }
      }
    }

    return msPath;
  };

  return (
    <div
      className={classNames(style.container, "size-14")}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-label={`Navigate to ${title}`}
    >
      <span>{title}</span>

      {hasIconOption && (
        <button
          type="button"
          className={style.button}
          data-testid="arrowButton"
        >
          <i
            className={
              isExternal
                ? "fa tg-icons-Open size-14"
                : "fa tg-icons-LeftArrow size-14"
            }
          ></i>
        </button>
      )}
    </div>
  );
};

MenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  msPath: PropTypes.string,
  isExternal: PropTypes.bool,
  children: PropTypes.array,
  level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  hasIconOption: PropTypes.bool,
};
